/* src/app/components/order-page-toolbar/order-page-toolbar.component.scss */
.order-page-toolbar {
  background: var(--order-toolbar-color);
  align-items: center;
  min-height: 56px;
  flex-wrap: nowrap;
  padding-inline: 25px;
}
.title-block {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
}
.title {
  font-size: 18px;
  letter-spacing: 0;
  text-align: left;
  color: var(--ion-color-secondary);
}
ion-icon {
  height: 16px;
  width: 16px;
}
app-preorder-type-chip {
  margin-left: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}
app-burger-btn {
  position: relative;
  right: 10px;
}
@media (min-width: 991px) {
  app-burger-btn {
    display: none;
  }
}
::ng-deep .button-solid {
  --padding-start: 0px;
  --padding-end: 0px;
}
/*# sourceMappingURL=order-page-toolbar.component.css.map */
